import { TableSchema } from '../metadata-schema';
import { instelling } from './instelling';
import { dim_vs_vestiging } from './dim_vs_vestiging';
import { dim_lg_lesgroep } from './dim_lg_lesgroep';
import { dim_mw_medewerker } from './dim_mw_medewerker';
import { dim_vk_vak } from './dim_vk_vak';

export const fac_af_afspraak: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_af_afspraak",
	"description": "Definitie voor fact tabel fac_af_afspraak uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vakspecifiek"
	],
	"properties": {
		"af_abbs_medewerker": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"label": "Docent (afkorting)",
			"category": "Vak",
			"example": "JNS, VDK",
			"description": "De afkortingen van de docenten die aan deze les zijn gekoppeld.",
			"allowlist": {
				"beheer": true
			},
			"blocklist": {
				"bestuur": true
			}
		},
		"af_abbs_vak": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"label": "Vak (afk)",
			"category": "Vak",
			"example": "entl, wisA, ...",
			"description": "De afkortingen van de vakken van deze les.\nEen afspraak kan aan meerdere vakken gekoppeld zijn, bijvoorbeeld bij een combinatieles."
		},
		"af_d_datum": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"af_fk_inst": {
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"af_fk_vs": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"af_fks_lg": {
			"type": "array",
			"items": {
				"include": [],
				"description": "Definitie voor dimension tabel dim_lg_lesgroep uit de CumLaude DWH",
				"type": "object",
				"schema": dim_lg_lesgroep
			}
		},
		"af_fks_mw": {
			"type": "array",
			"items": {
				"include": [],
				"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
				"type": "object",
				"schema": dim_mw_medewerker
			}
		},
		"af_fks_vk": {
			"type": "array",
			"items": {
				"include": [],
				"description": "Definitie voor dimension tabel dim_vk_vak uit de CumLaude DWH",
				"type": "object",
				"schema": dim_vk_vak
			}
		},
		"af_id_afspraak": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"af_id_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description-somtoday": "De vestiging van deze afspraak. Een afspraak heeft in Somtoday altijd precies één vestiging;\ndie van de les, ook als er gastleerlingen van een andere vestiging aan deelnemen.",
			"description-magister": "De vestiging van deze afspraak. Magister levert geen vestiging bij de afspraak; deze is\nafgeleid als de meest voorkomende vestiging van de deelnemende leerlingen."
		},
		"af_is_presentieregistratie_verplicht": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Presentieregistratie verplicht",
			"category": "Afwezigheid",
			"example": "Ja, Nee",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Geeft aan of in het afspraaktype van deze les is aangegeven dat er een presentieregistratie moet plaatsvinden.",
			"blocklist": {
				"magister": true
			}
		},
		"af_is_presentieregistratie_verwerkt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Afgesloten les",
			"category": "Afwezigheid",
			"example": "Ja, Nee",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Geeft aan of deze les is \"afgesloten\": presentie is geregistreerd.\nAnders dan bij aanwezigheid is dit per afspraak vastgelegd, en niet afgeleid over alle lessen\ndie een leerling op hetzelfde lesuur had."
		},
		"af_nm_afspraaktype": {
			"type": "string",
			"label": "Afspraaktype",
			"category": "Afwezigheid",
			"example": "Les, Kwt, Persoonlijk, ...",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description-somtoday": "Het type van deze afspraak.",
			"description-magister": "Het type van deze afspraak.\nDe mogelijke waarden zijn: Onbekend, Persoonlijk, Algemeen, Schoolbreed, Stage, Kwt, Les of Planning."
		},
		"af_nm_bron": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"af_nm_schooljaar": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"af_nms_lesgroep": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"label": "Lesgroep",
			"category": "Vak",
			"example": "1een, h5cnetl, ...",
			"description": "De namen van de lesgroepen die aan deze les zijn gekoppeld."
		},
		"af_nms_medewerker": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"label": "Docent",
			"category": "Vak",
			"example": "Jansen, L. (JNS); Dijk, Evert van (VDK)",
			"description": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de docenten die aan deze les zijn gekoppeld.",
			"blocklist": {
				"bestuur": true
			}
		},
		"af_nms_vak": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"label": "Vak",
			"category": "Vak",
			"example": "Engels, wiskunde A, ...",
			"description": "De vakken van deze les.\nEen afspraak kan aan meerdere vakken gekoppeld zijn, bijvoorbeeld bij een combinatieles."
		},
		"af_nr_lesuur_tm": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"af_nr_lesuur_va": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"af_t_begin": {
			"type": "string",
			"format": "time",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"af_t_eind": {
			"type": "string",
			"format": "time",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"af_ts_begin": {
			"type": "string",
			"format": "date-time",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"af_ts_eind": {
			"type": "string",
			"format": "date-time",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
